"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoReactInternals = exports.random = exports.interpolate = void 0;
var interpolate_1 = require("./interpolate");
Object.defineProperty(exports, "interpolate", { enumerable: true, get: function () { return interpolate_1.interpolate; } });
var random_js_1 = require("./random.js");
Object.defineProperty(exports, "random", { enumerable: true, get: function () { return random_js_1.random; } });
const delay_render_1 = require("./delay-render");
const input_props_serialization_1 = require("./input-props-serialization");
const interpolate_colors_1 = require("./interpolate-colors");
const truthy_1 = require("./truthy");
const validate_frame_1 = require("./validate-frame");
const validate_default_props_1 = require("./validation/validate-default-props");
const validate_dimensions_1 = require("./validation/validate-dimensions");
const validate_duration_in_frames_1 = require("./validation/validate-duration-in-frames");
const validate_fps_1 = require("./validation/validate-fps");
const get_current_time_1 = require("./video/get-current-time");
const offthread_video_source_1 = require("./video/offthread-video-source");
exports.NoReactInternals = {
    processColor: interpolate_colors_1.processColor,
    truthy: truthy_1.truthy,
    validateFps: validate_fps_1.validateFps,
    validateDimension: validate_dimensions_1.validateDimension,
    validateDurationInFrames: validate_duration_in_frames_1.validateDurationInFrames,
    validateDefaultAndInputProps: validate_default_props_1.validateDefaultAndInputProps,
    validateFrame: validate_frame_1.validateFrame,
    serializeJSONWithDate: input_props_serialization_1.serializeJSONWithDate,
    bundleName: 'bundle.js',
    bundleMapName: 'bundle.js.map',
    deserializeJSONWithCustomFields: input_props_serialization_1.deserializeJSONWithCustomFields,
    DELAY_RENDER_CALLSTACK_TOKEN: delay_render_1.DELAY_RENDER_CALLSTACK_TOKEN,
    getOffthreadVideoSource: offthread_video_source_1.getOffthreadVideoSource,
    getExpectedMediaFrameUncorrected: get_current_time_1.getExpectedMediaFrameUncorrected,
};
